// @ts-nocheck
/* eslint-disable */
import Scene from "~/scene";

Mapy.LayerCanvasGeom = function(id, options) {
	this._canvasColor = null;
	this._ctxColor = null;
	// nastaveni
	this._parseColor = false;
	this._diffOpacity = false;
	this._options = options;
	this._colorMap = {};
	this._color = [0, 0, 0];
	this._geoms = [];

	this._nextColor();


	Mapy.LayerTraffic.call(this, id || "layer-canvas-geom");
}

Mapy.LayerCanvasGeom.prototype = Object.create(Object.assign({}, SMap.Layer.prototype, Mapy.LayerTraffic.prototype));

Mapy.LayerCanvasGeom.prototype._build = function() {
	this._canvas = document.createElement("canvas");
	this._canvas.style.position = "absolute";
	this._ctx = this._canvas.getContext("2d");

	this._canvasColor = document.createElement("canvas");
	this._canvasColor.style.position = "absolute";
	this._ctxColor = this._canvasColor.getContext("2d", { alpha: false });
	this._ctxColor.imageSmoothingEnabled = false;

	/*this._dom.container[SMap.LAYER_CANVAS] = Mapy.Util.node("div");
	this._dom.container[SMap.LAYER_CANVAS].appendChild(this._canvas);
	this._dom.container[SMap.LAYER_CANVAS].appendChild(this._canvasColor);*/
	this._dom.container[SMap.LAYER_CANVAS] = this._canvas;
};

Mapy.LayerCanvasGeom.prototype.geometryOnCursor = function(x, y) {
	let imgData = this._ctxColor.getImageData(x, y, 1, 1);

	if (imgData.data[3] == 255) {
		let geom = this._colorMap[`${imgData.data[0].toString().lpad("0", 3)}${imgData.data[1].toString().lpad("0", 3)}${imgData.data[2].toString().lpad("0", 3)}`];

		if (geom) {
			let i = this._geometries.indexOf(geom);

			if (this._geoms[i]) {
				return this._geoms[i];
			}
		}
	}

	return null;
};

Mapy.LayerCanvasGeom.prototype.clear = function() {
	let settings = Mapy.LayerTraffic.prototype.clear.call(this);

	if (this._canvasColor && settings.size) {
		this._canvasColor.width = settings.size.x;
		this._canvasColor.height = settings.size.y;
		/*this._canvasColor.style.left = settings.position.x + "px";
		this._canvasColor.style.top = settings.position.y + "px";*/
	}

	this._colorMap = {};
	this._color = [0, 0, 0];
	this._nextColor();
}

Mapy.LayerCanvasGeom.prototype.redraw = function(full) {
	if (!this._active) return;

	this._draw();
}

Mapy.LayerCanvasGeom.prototype.drawGeometries = function(geoms) {
	this._geoms = geoms;
	this._geometries = [];

	for (let i = 0; i < geoms.length; i++) {
		let g = geoms[i];
		let crds = g.getCoords();
		let coords = [];

		for (let indx = 0; indx < crds.length; indx++) {
			let c = crds[indx];

			if (c.x && c.y) {
				let wgs84 = c.toWGS84();
				coords.push(Scene.coordsFromWGS84(wgs84[0], wgs84[1]));
			}
			else {
				coords.push(c);
			}
		}

		this._geometries.push({
			coords,
			style: g.getOptions()
		});
	}

	if (!this._active) return;

	this._draw();
};

Mapy.LayerCanvasGeom.prototype.up = function() {
	delete this._dom.container[SMap.LAYER_SHADOW];
	this._dom.container[SMap.LAYER_CANVAS] = this._canvas;
}

Mapy.LayerCanvasGeom.prototype.down = function() {
	this._dom.container[SMap.LAYER_SHADOW] = this._canvas;
	delete this._dom.container[SMap.LAYER_CANVAS];
}

/**
 * Nastaveni kresleni.
 */
Mapy.LayerCanvasGeom.prototype._drawSetup = function(map) {
	let setupData = Mapy.LayerTraffic.prototype._drawSetup.call(this, map);

	if (this._canvasColor) {
		this._canvasColor.width = setupData.size.x;
		this._canvasColor.height = setupData.size.y;
	}

	return setupData;
};

Mapy.LayerCanvasGeom.prototype._setStyle = function(geomStyle) {
	let style = Mapy.LayerTraffic.prototype._setStyle.call(this, geomStyle);

	if (style.minDist) {
		// nemame jak nahradit
		delete style.minDist;
	}

	// styl - jak na SVG
	if (style.endCap) {
		switch (style.endCap) {
			case JAK.Vector.END_STYLE_ROUND: style.cap = "round"; break;
			case JAK.Vector.END_STYLE_SQUARE: style.cap = "square"; break;
			case JAK.Vector.END_STYLE_BUTT: style.cap = "butt"; break;
		}
		delete style.endCap;
	}

	if (style["style"]) {
		delete style["style"];
	}

	if (style["outlineStyle"]) {
		delete style["outlineStyle"];
	}

	let parseExactStyle = i => {
		if (style[i.jak]) {
			style[i.name] = [];

			let parts = style[i.jak].match(/(\d+)\w*\s*(\d+)/);

			if (parts && parts.length == 3) {
				style[i.name].push(parseFloat(parts[1]));
				style[i.name].push(parseFloat(parts[2]));
			}

			delete style[i.jak];
		}
	}

	parseExactStyle({ jak: "exactStyle", name: "dash" });
	parseExactStyle({ jak: "outlineExactStyle", name: "outlineDash" });

	if (style.outlineWidth && style.width && style.outlineWidth < style.width) {
		style.outlineWidth = style.width + style.outlineWidth;
	}

	if (this._parseColor) {
		if (style.opacity) {
			if (style.opacity < 1) {
				let color = style.color || "#000";
				style.color = this._setColorOpacity(color, this._diffOpacity ? 1 - style.opacity : style.opacity);
			}

			delete style.opacity;
		}

		if (style.outlineOpacity) {
			if (style.outlineOpacity < 1) {
				let color = style.outlineColor || "#000";
				style.outlineColor = this._setColorOpacity(color, this._diffOpacity ? 1 - style.outlineOpacity : style.outlineOpacity);
			}

			delete style.outlineOpacity;
		}
	}

	return style;
};

Mapy.LayerCanvasGeom.prototype._setColorOpacity = function(color, opacity) {
	let parsedColor = Mapy.Util.parseColor(color);

	return `rgba(${parsedColor.r}, ${parsedColor.g}, ${parsedColor.b}, ${opacity})`;
};

Mapy.LayerCanvasGeom.prototype._drawPixels = function(ctx, pixels, ctxStyle, geom, noEvent) {
	ctx.beginPath();
	if (!noEvent) {
		this._ctxColor.beginPath();

		// nastavime styl
		this._ctxColor.globalAlpha = 1;
		this._ctxColor.lineCap = "butt";
		this._ctxColor.lineJoin = "miter";
		this._ctxColor.strokeStyle = `rgb(${this._color[0]}, ${this._color[1]}, ${this._color[2]})`;
		this._ctxColor.lineWidth = (ctxStyle.lineWidth || 1) + (this._options && this._options.mouseReactExtension ? this._options.mouseReactExtension : 0);
		this._ctxColor.fillStyle = `rgb(${this._color[0]}, ${this._color[1]}, ${this._color[2]})`;

		this._colorMap[`${this._color[0].toString().lpad("0", 3)}${this._color[1].toString().lpad("0", 3)}${this._color[2].toString().lpad("0", 3)}`] = geom;
	}

	// cary
	for (let i = 0; i < pixels.length; i++) {
		let pixel = pixels[i];

		ctx.lineTo(pixel.x, pixel.y);
		if (!noEvent) {
			this._ctxColor.lineTo(Math.round(pixel.x), Math.round(pixel.y));
		}
	}

	ctx.stroke();
	if (!noEvent) {
		this._ctxColor.stroke();
	}

	ctx.closePath();
	if (!noEvent) {
		this._ctxColor.closePath();

		this._nextColor();
	}
}

Mapy.LayerCanvasGeom.prototype._drawPoint = function(ctx, point, ctxStyle) {
	ctx.beginPath();
	this._ctxColor.beginPath();

	// nastavime styl
	this._ctxColor.globalAlpha = 1;
	this._ctxColor.fillStyle = `rgb(${this._color[0]}, ${this._color[1]}, ${this._color[2]})`;

	this._colorMap[`${this._color[0].toString().lpad("0", 3)}${this._color[1].toString().lpad("0", 3)}${this._color[2].toString().lpad("0", 3)}`] = point.geom;

	// pointy
	for (let i = 0; i < point.pixels.length; i++) {
		let pixel = point.pixels[i];
		ctx.arc(pixel.x, pixel.y, point.radius, 0, 2 * Math.PI, false);
		// u bodu do barev musime pripocitat k radiusu i velikost stroku (ten se vyhlazuje a dela to blbosti, proto ho tu nepouzivame)
		this._ctxColor.arc(Math.round(pixel.x), Math.round(pixel.y), point.radius + (ctxStyle.lineWidth || 1) + (this._options && this._options.mouseReactExtension ? this._options.mouseReactExtension : 0), 0, 2 * Math.PI, false);
	}

	ctx.closePath();
	this._ctxColor.closePath();

	ctx.fill();
	ctx.stroke();
	this._ctxColor.fill();

	this._nextColor();
}

Mapy.LayerCanvasGeom.prototype._nextColor = function() {
	if (this._color[0] < 255) {
		this._color[0] += 5;
	}
	else if (this._color[1] < 255) {
		if (this._color[0] == 255) {
			this._color[0] = 0;
		}

		this._color[1] += 5;
	}
	else if (this._color[2] < 255) {
		if (this._color[0] == 255) {
			this._color[0] = 0;
		}

		if (this._color[1] == 255) {
			this._color[1] = 0;
		}

		this._color[2] += 5;
	}
}

Mapy.LayerCanvasGeom.prototype.fillFromData = function(data) {
	if (!this._active) return;

	this._geoms = [];

	for (let i = 0; i < data.length; i++) {
		let lookup = data[i];

		const pois = lookup?.poi?.filter(i => this._options.typeIds.indexOf(i.typeId) !== -1) || [];
		const geometries = [];

		pois.forEach(poi => {
			if (poi.geom) {
				poi.geom.data.forEach(data => {
					this._geoms.push(poi);

					geometries.push({
						coords: Scene.stringToCoords(data),
						style: poi.geom.style,
					});
				});
			}
		});

		this._geometries = geometries;

		this._draw();
	}
};
